import {
  DerivativesMarginMode,
  SetCustomerTradingPairLeverageRequest,
  SetCustomerTradingPairMarginModeRequest,
  SetDerivativesPositionModeRequest,
} from 'common/api/autogenerated/trading-gateway';

import { defaultValues } from 'views/derivatives/dashboard/components/OrderForm/constants';

const TEMP_FUTURES_CONFIGURATION_KEY = 'webtrader:futures:temp-configuration';

type ConfigurationValueType = SetCustomerTradingPairLeverageRequest &
  SetDerivativesPositionModeRequest &
  SetCustomerTradingPairMarginModeRequest;

export const tempFuturesConfigurator = {
  update: (symbol: string, value: ConfigurationValueType): void => {
    const key = `${TEMP_FUTURES_CONFIGURATION_KEY}:${symbol}`;
    const previousConfig = localStorage.getItem(key);
    const config = previousConfig ? { ...JSON.parse(previousConfig), ...value } : value;
    try {
      localStorage.setItem(key, JSON.stringify(config));
    } catch (e) {
      console.log(e);
    }
  },
  get: (symbol: string): ConfigurationValueType => {
    const key = `${TEMP_FUTURES_CONFIGURATION_KEY}:${symbol}`;
    try {
      const config = JSON.parse(localStorage.getItem(key) || '{}');

      const output: ConfigurationValueType = {
        leverage: defaultValues.leverage!,
        positionMode: defaultValues.positionMode,
        marginMode: defaultValues.marginMode,
      };

      if (config.leverage && typeof config.leverage === 'number') output.leverage = config.leverage;

      // 85523 TEMP COMMENTED
      // if (
      //   config.positionMode &&
      //   (config.positionMode === DerivativesPositionMode.ONE_WAY ||
      //     config.positionMode === DerivativesPositionMode.HEDGE)
      // )

      output.positionMode = config.positionMode;
      if (
        config.marginMode &&
        (config.marginMode === DerivativesMarginMode.CROSS || config.marginMode === DerivativesMarginMode.ISOLATED)
      )
        output.marginMode = config.marginMode;

      return output;
    } catch (e) {
      console.log(e);
      return {};
    }
  },
  clear: (symbol: string): void => {
    const key = `${TEMP_FUTURES_CONFIGURATION_KEY}:${symbol}`;
    try {
      localStorage.removeItem(key);
    } catch (e) {
      console.log(e);
    }
  },
};
